module.exports = __webpack_public_path__ + "cc066860e6f0d53d0a336b18cfb2905a.png";